module.exports = __webpack_public_path__ + "img/motor_grader_h.df365251.png";